import React, {Suspense, lazy} from "react";
import {BrowserRouter, Switch, Route, Redirect} from "react-router-dom";
import {ThemeProvider, CSSReset, Flex} from "@chakra-ui/core";

import {Provider as CartProvider} from "../cart/context";
import {Provider as TenantProvider} from "../tenant/context";
import {Provider as ProductProvider} from "../product/context";
import ProductsScreen from "../product/screens/Products";

import AdminScreen from "./screens/Admin";
import LoadingScreen from "./screens/Loading";
import Header from "./components/Header";
import getTheme from "./theme";

const LandingScreen = lazy(() => import("./screens/Landing"));

const App: React.FC = () => (
  <ThemeProvider theme={getTheme()}>
    <CSSReset />
    <BrowserRouter>
      <Flex direction="column" height="100%">
        <Suspense fallback={<LoadingScreen />}>
          <Switch>
            <Route exact component={LandingScreen} path="/" />
            <Route path="/:tenant">
              <TenantProvider>
                <Header />
                <ProductProvider>
                  <CartProvider>
                    <Switch>
                      <Route exact component={AdminScreen} path="/:tenant/admin" />
                      <Route exact component={ProductsScreen} path="/:tenant" />
                      <Redirect to="/" />
                    </Switch>
                  </CartProvider>
                </ProductProvider>
              </TenantProvider>
            </Route>
            <Redirect to="/" />
          </Switch>
        </Suspense>
      </Flex>
    </BrowserRouter>
  </ThemeProvider>
);

export default App;
